import React from 'react'

const AddRadiusIcon = () => {
    return (
        <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.50049 9.00781H11.5005" stroke="#292D32" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.5011 12V6" stroke="#292D32" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.25 16.5H10.75C14.5 16.5 16 15 16 11.25V6.75C16 3 14.5 1.5 10.75 1.5H6.25C2.5 1.5 1 3 1 6.75V11.25C1 15 2.5 16.5 6.25 16.5Z" stroke="#292D32" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default AddRadiusIcon